import {FC} from "react";
import {
    Box,
    Tooltip,
} from "@mui/material";
import {Locale} from "../locales/Locale";
import {IdlocaGeneric} from "../locales/IdlocaGeneric";
import {GetSvgIcon} from "../components/GetSvgIcon";
import {IconNames} from "../enums/Icons";

// TODO move out to configs
const FBURL = "https://www.facebook.com/groups/2084128605333319";

export const FacebookLink: FC = () => {
    return (
        <Tooltip title={<Locale localeId={IdlocaGeneric.find_us_on_facebook}/>} arrow>
            <Box
                component="a"
                href={FBURL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{display: "flex", alignItems: "center"}}
            >
                <GetSvgIcon name={IconNames.Facebook} style={{width: 24, height: 24}}/>
            </Box>
        </Tooltip>
    );
};
